import CircularProgress, {
  CircularProgressProps
} from '@mui/material/CircularProgress';

import Box from '@mui/material/Box';
import React from 'react';
import Typography from '@mui/material/Typography';
import { isNumber } from 'lodash';

export function CircularProgressWithValue(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress
        variant={isNumber(props.value) ? 'determinate' : 'indeterminate'}
        {...props}
      />
      {isNumber(props.value) && (
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="caption"
            component="div"
            color="textSecondary"
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      )}
    </Box>
  );
}
